import axios from "axios";
import { ROUTES } from "./constants/routes";

function isJwtProblem(err: any): boolean {
  const status = err?.response?.status;
  const msg = String(err?.response?.data?.errorMsg || err?.message || "").toLowerCase();
  return (
    status === 401 ||
    msg.includes("jwt malformed") ||
    msg.includes("jwt expired") ||
    msg.includes("invalid token") ||
    msg.includes("not authorized") ||
    msg.includes("unauthorized")
  );
}

function redirectToLoginOnce() {
  try {
    if (window.location.hash === `#${ROUTES.login}` || window.location.hash === "#/") {
      return;
    }
    sessionStorage.clear();
    window.location.hash = `#${ROUTES.login}`;
    window.location.reload();
  } catch {
    window.location.href = `#${ROUTES.login}`;
  }
}

function logoutOnWindowClose() {
  const token = sessionStorage.getItem("token");
  if (!token) return;
  const apiBase = process.env.REACT_APP_BACK_END_API;
  if (!apiBase) return;
  fetch(`${apiBase}/auth/logout`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    keepalive: true,
  }).catch(() => {});
}

let installed = false;

export function installAxiosInterceptors() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      if (isJwtProblem(err)) {
        redirectToLoginOnce();
      }
      return Promise.reject(err);
    }
  );

  window.addEventListener("pagehide", logoutOnWindowClose);
}
